const apiUrl = process.env.API_URL || 'http//localhost:3001';

const api = {
	baseURL: process.env.LOCAL ? `http://localhost:3001` : apiUrl,
	cdnURL: 'https://s3.eu-west-2.amazonaws.com/merlin-cloud-storage',
	example: {
		example: `/example`,
	},
	accounts: {
		account: '/account',
		updateAccount: '/account',
		avatar: (id: string) => `/account/avatar/${id}`,
	},

	documents: {
		documents: '/document',
		download: '/document/download',
		document: (id: string) => `/document/${id}`,
		delete: `/document`,
	},
	links: {
		all: '/link',
		link: (id: string) => `/link/${id}`,
		delete: `/link`,
		edit: (id: string) => `/link/${id}`,
		create: `/link`,
	},
	audit: {
		all: '/audit',
		link: (id: string) => `/audit/${id}`,
		create: `/audit`,
	},
	forms: {
		all: '/form',
		form: (id: string) => `/form/${id}`,
		delete: `/form`,
		edit: (id: string) => `/form/${id}`,
		create: `/form`,
	},
	formSubmission: {
		all: '/form-submission',
		form: (id: string) => `/form-submission/${id}`,
		delete: `/form-submission`,
		edit: (id: string) => `/form-submission/${id}`,
		create: `/form-submission`,
	},

	comments: {
		comment: (id: string) => `/comment/${id}`,
		all: `/comment`,
		delete: `/comment`,
		edit: (id: string) => `/comment/${id}`,
		create: `/comment`,
	},

	admin: {
		auth: '/admin/auth',
		users: '/admin/auth',
		suspend: (id: string) => `/admin/account/suspend/${id}`,
		user: '/admin/auth/user',
		delete: (id: string) => `/admin/auth/${id}`,
	},
	auth: {
		social: {
			googleUrl: '/auth/social/google-url',
		},
		session: {
			get: '/auth/session',
			deleteAll: '/auth/session/',
			delete: (id: string) => `/auth/session/${id}`,
		},
		code: {
			validate: '/auth/validateCode',
			resend: '/auth/resendCode',
		},
		magicLogin: {
			start: '/auth/magic/start',
			finish: '/auth/magic/finish',
		},
		invite: '/auth/invite',
		concierge: {
			get: `/auth/concierge/get`,
			finish: '/auth/concierge/finish',
		},
		preLogin: '/auth/preLogin',
		register: '/auth/register',
		login: '/auth/login',
		account: '/account',
		user: (id: string) => `/account/user/${id}`,
		refresh: '/auth/refresh',
		password: {
			start: '/auth/password/forgot/start',
			finish: '/auth/password/forgot/finish',
			change: '/auth/password/change',
		},
		email: {
			verify: '/auth/email/verify',
			start: '/auth/email/change/start',
			finish: '/auth/email/change/finish',
		},
		phone: {
			link: {
				start: '/auth/phone/link/start',
				finish: '/auth/phone/link/finish',
			},
			unlink: {
				start: '/auth/phone/unlink/start',
				finish: '/auth/phone/unlink/finish',
			},
		},
	},
};

export default api;
